import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    OverPack: {
      playScale: 0.3,
    },
    wrapper: {
      className: 'home-page-wrapper feature20',
    },
    title: {
      className: 'feature20-title',
      children: '交通优势',
    },
    bg: {
      className: 'bg',
      children:
        'https://imm.86links.com/assets/landing/feature/Feature20-img/bg.png',
    },
    content: {
      className: 'feature20-content',
      children: [
        {
          name: 'item0',
          className: 'feature20-content-item',
          img: {
            className: 'feature20-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/centre-1.png',
          },
          icon: {
            className: 'feature20-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/icon-1.png',
          },
          title: {
            className: 'feature20-content-item-title',
            children: '航空',
          },
          content: {
            className: 'feature20-content-item-content',
            children:
              '区域距成都双流国际机场<strong>20公里</strong></br>天府国际机场<strong>30公里</strong>',
          },
        },
        {
          name: 'item1',
          className: 'feature20-content-item',
          img: {
            className: 'feature20-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/centre-2.png',
          },
          icon: {
            className: 'feature20-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/icon-2.png',
          },
          title: {
            className: 'feature20-content-item-title',
            children: '内陆口岸',
          },
          content: {
            className: 'feature20-content-item-content',
            children:
              '四川省唯一公路口岸：<strong>成都公路口岸</strong></br>以及以其为始发点的成都西部陆海新通道',
          },
        },
        {
          name: 'item2',
          className: 'feature20-content-item',
          img: {
            className: 'feature20-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/centre-3.png',
          },
          icon: {
            className: 'feature20-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/icon-3.png',
          },
          title: {
            className: 'feature20-content-item-title',
            children: '公路',
          },
          content: {
            className: 'feature20-content-item-content',
            children:
              '成安渝、成南、成渝、五环路、东安大道等高速、快速路穿境而过，形成“<strong>八横五纵</strong>“内联外畅骨干路网',
          },
        },
        {
          name: 'item3',
          className: 'feature20-content-item',
          img: {
            className: 'feature20-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/centre-4.png',
          },
          icon: {
            className: 'feature20-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/feature/Feature20-img/icon-4.png',
          },
          title: {
            className: 'feature20-content-item-title',
            children: '铁路',
          },
          content: {
            className: 'feature20-content-item-content',
            children:
              '成都拥有亚洲最大的铁路集装箱中心站，蓉欧班列形成“<strong>三线并行</strong>”的格局；正在打造国家高铁枢纽城市',
          },
        },
      ],
    },
  },
};
